import Vue from 'vue';

// Styles
import 'styles/pages/events/index/index.scss';

// Scripts
import '~scripts/main';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import initRequestForm from '~scripts/blocks/request-form';

// Components
import '~scripts/components/modals';
import SubscribeForm from '~scripts/components/vue/forms/SubscribeForm.vue';

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// EVENT CARD
//
import EventCardsList from './EventCardsList.vue';

const eventsList = document.querySelectorAll('.js-events-list');

eventsList.forEach((element) => {
  new Vue({
    el: element,
    name: 'EventCardsList',
    components: {
      EventCardsList,
    },
  });
});

//
// DEMO REQUEST FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

//
// SUBSCRIBE FORM
//
const formWrapper = document.querySelector('.js-form-wrapper');

new Vue({
  el: formWrapper,
  components: {
    SubscribeForm: SubscribeForm,
  },
});

//
// TABS
//
import initEventsTabs from '~scripts/pages/events/index/events-tabs';

initEventsTabs();
